import { useDroppable } from "@dnd-kit/core";
import { Box } from "@mui/material";
import type { FC } from "react";

type DropZoneProps = {
	index: number;
	amountOfWeeks: number;
	isVisible: boolean;
};

export const SectionDropZone: FC<DropZoneProps> = ({ index, amountOfWeeks, isVisible }) => {
	const { setNodeRef, isOver } = useDroppable({
		id: `section-drop-${index}`,
		data: {
			type: "section-drop",
			targetIndex: index,
		},
	});

	if (!isVisible) return null;

	return (
		<Box
			ref={setNodeRef}
			sx={(theme) => ({
				gridColumn: `span ${2 + 7 * amountOfWeeks}`,
				height: isOver ? "4px" : "2px",
				background: isOver ? theme.palette.primary.main : theme.palette.primary.light,
				transition: "all 150ms ease",
				my: isOver ? 0.5 : 0.25,
			})}
		/>
	);
};
